package com.patronat.top.client

import androidx.compose.runtime.Composable
import com.patronat.top.client.di.clientAppModules
import com.patronat.top.client.presentation.root.ClientRoot
import com.patronat.top.ui.theme.AppTheme
import org.koin.core.KoinApplication as CoreKoinApplication
import org.koin.compose.KoinApplication

@Composable
fun ClientApp(
    webMode: Boolean = false,
    configureKoin: CoreKoinApplication.() -> Unit = {}
) {
    KoinApplication(application = {
        configureKoin()
        modules(clientAppModules)
    }) {
        AppTheme {
            ClientRoot(webMode = webMode)
        }
    }
}
